<template>
    <div class="lotteryGold">
        <p class="page">{{lotteryGold.Deposit}}</p>
        <div class="lottleList">
            <ul class="pageUl">
                <li :class="actIndex == 3 ? 'activited' : ''" @click="checkTab(3)">{{lotteryGold.all}}</li>
                <li :class="actIndex == 0 ? 'activited' : ''" @click="checkTab(0)">{{lotteryGold.available}}</li>
                <li :class="actIndex == 1 ? 'activited' : ''" @click="checkTab(1)">{{lotteryGold.Received}}</li>
                <li :class="actIndex == 2 ? 'activited' : ''" @click="checkTab(2)">{{lotteryGold.Expired}}</li>
            </ul>
            <div class="nothing" v-show="flag" style="margin-top:50px">
                <img loading="lazy" class="nothing-image" v-lazy="require('../../../assets/images/yy/noData.png')" />
                <p style="margin-top:30px">{{lotteryGold.nodata}}</p>
            </div>
            <div class="lotterList"  v-show="!flag" v-infinite-scroll="load" infinite-scroll-immediate="false" >
                    <!-- 全部box -->
                    <div class="All setHeiaht" v-show="actIndex == 3"  >
						<div :class="item.state === 0 ? 'Getnow': item.state === 1 ? 'Received':'Expired'"  v-for="(item,index) in dataList" :key='index'>
							<div class="box boxShadow">
								<p class="goldTitme">{{item.name}}</p>
								<p class="shoeMoney">￥{{filterNumber(item.amount)}}</p>
								<div class="showBtn cuosing" @click="openDial(item)" v-if="item.state === 0">{{lotteryGold.getnow}}</div>
								<div class="showBtn disbtn1" v-if="item.state === 1" @click="openTip(1)">{{lotteryGold.Received}}</div>
								<div class="showBtn disbtn" v-if="item.state === 2" @click="openTip(2)">{{lotteryGold.Expired}}</div>
								<p class="timeqq">{{lotteryGold.Validuntil}}:</p>   <!-- 领取有效截止 -->
								<p class="timeqq"> {{item.overdueTime}}</p>
							</div>
						</div>
                    </div>
                    <!-- 可领取box -->
                    <div class="Getnow setHeiaht"  v-show="actIndex == 0">
                        <div class="box boxShadow"  v-for="(item,index) in dataList" :key='index'>
                            <p class="goldTitme">{{item.name}}</p>
                            <p class="shoeMoney">￥{{filterNumber(item.amount)}}</p>
                            <div class="showBtn cuosing" @click="openDial(item)">{{lotteryGold.getnow}}</div>
                            <p class="timeqq">{{lotteryGold.Validuntil}}:</p>
                            <p class="timeqq"> {{item.overdueTime}}</p>
                        </div>
                    </div>
                    <!-- 已领取box -->
                    <div class="Received setHeiaht"  v-show="actIndex == 1">
                        <div class="box boxShadow"  v-for="(item,index) in dataList" :key='index'>
                            <p class="goldTitme">{{item.name}}</p>
                            <p class="shoeMoney">￥{{filterNumber(item.amount)}}</p>
                            <div class="showBtn disbtn1" @click="openTip(1)">{{lotteryGold.Received}}</div>
                            <p class="timeqq">{{lotteryGold.Validuntil}}:</p>
                            <p class="timeqq"> {{item.overdueTime}}</p>
                        </div>
                    </div>   
                    <!-- 已过期box -->
                    <div class="Expired setHeiaht"  v-show="actIndex == 2">
                        <div class="box boxShadow"  v-for="(item,index) in dataList" :key='index'>
                            <p class="goldTitme">{{item.name}}</p>
                            <p class="shoeMoney">￥{{filterNumber(item.amount)}}</p>
                            <div class="showBtn disbtn" @click="openTip(2)">{{lotteryGold.Expired}}</div>
                            <p class="timeqq">{{lotteryGold.Validuntil}}:</p>
                            <p class="timeqq"> {{item.overdueTime}}</p>
                        </div>
                    </div>
                <p v-show="loadingType == 'loading'" style="margin-top:10px;" class="Atext">{{$t('lotteryGold.Loading')}}</p>
                <p v-show="loadingType == 'more'" style="margin-top:10px;" class="Atext">{{$t('lotteryGold.Pullmore')}}</p>
                <p v-show="loadingType == 'noMore'" style="margin-top:10px;" class="Atext">{{$t('lotteryGold.ThereNOdata')}}</p>
            </div>
        </div>
        <!-- 领取弹窗 -->
        <el-dialog
        class="dailog"
        :title="lotteryGold.LotterCo"
        :visible.sync="dialogVisible"
        :show-close='false'
        center
        top='30vh'
        width="394px">
            <div style="text-align:center" class="showmonbox">
                <p class="showmon" v-if='receiveflag'>￥{{filterNumber(amount)}}</p>
                <p class="bei"  v-if='receiveflag'>{{lotteryGold.flowdemand}}{{multiple}} {{lotteryGold.bei}}</p>
                <span class="bei"  v-if='!receiveflag'>{{lotteryGold.succeeded}},{{lotteryGold.toSee}}</span> <!-- 领取成功，请前往余额查看 -->
            </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">{{lotteryGold.cancel}}</el-button>
            <el-button type="primary" @click="getNow">{{receiveflag ? lotteryGold.getnow : lotteryGold.Isee}}</el-button>
        </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
   data(){
       return {
           loading:true,
           flag:true,
           actIndex:3,
           currentPage:1,
           dataList:[],
           loadingType:'more',
           dialogVisible:false,
           amount:0,
           multiple:0,
           symbol:'',
           receiveId:null,
           totalPages:1, //总页数
           receiveflag:true,  //判断是否领取成功
       }
   },
   mounted(){
       this.dataList = [];
       this.loadingType ='more';
       this.symbol = window.symbol;
       this.getListData(this.currentPage,3)
   },
   methods:{
        openTip(type){
           if(type == 1){
                this.$notify({
                    iconClass: "",
                    message: this.$t('lotteryGold.beencollected'),   //"彩金已领取过了",
                    customClass: "myNotify",
                    showClose: false,
                    duration: 1000
                });
           }else{
                this.$notify({
                    iconClass: "",
                    message: this.$t('lotteryGold.unableClaim'),  //"已过期，无法领取!",
                    customClass: "myNotify",
                    showClose: false,
                    duration: 1000
                });
           }
         
       },
    //过滤数据
    filterNumber(num){
        if(num == 0){
            return "0.00";
        }else{
            return (num*1).toFixed(2)
        }
    },
    //加载更多
    load(){
        if(this.currentPage > this.totalPages) return;
        this.currentPage++;
        this.getListData(this.currentPage,this.actIndex)
    },
    //打开领取弹窗
    openDial(item){
        this.receiveflag = true;
        this.receiveId = item.id;
        this.amount = item.amount.toFixed(2);
        this.multiple = (item.amountAudit / item.amount).toFixed(2);
        this.dialogVisible = true;
    },
    //确定领取
    getNow(){
      if (this.receiveflag == false) {
            this.dialogVisible = false;
      } else {
        this.$http.get(this.$api.receive, this.receiveId).then(res => {
          if (res.code === 0) {
            this.checkTab(this.actIndex)
            this.mosaicGoldPush();
            this.receiveflag = false;
          } else {
            this.$message.error('领取失败');
          }
        })
      }
    },
    //点击领取之后改变彩金状态
    mosaicGoldPush() {
      this.$http.get(this.$api.getNotReceive).then(res => {
        if (res.code === 0) {
          if (res.data.notReceiveState) {
            this.$store.commit('mosaicGoldStatus', 2);
          } else {
            this.$store.commit('mosaicGoldStatus', 1);
          }
        }
      })
    },
    //切换彩金类型
    checkTab(type){
        this.actIndex = type;
        this.flag = false;
        this.dataList = [];
        this.loadingType ='more'
        this.currentPage = 1;
        this.getListData(1,this.actIndex)
    },
    //获取数据
    getListData(currentPage = 1, state = 3) {
        let that = this;
        that.loadingType = "loading"; //显示正在加载中。。。。
        let data = {
            pageSize: 10,
            currentPage,
            state
        }
        that.$http.post(that.$api.getAppList, data,true).then(res => {
            if (res && res.data && res.data.totalRecords > 0) {
                //处理时间
                res.data.content.map(item => {
                    item.createdAt = that.conversionTime(item.createdAt);
                    item.overdueTime = that.conversionTime(item.overdueTime);
                })
                if (currentPage == 1) {
                    that.dataList = res.data.content;
                } else {
                    that.dataList.push(...res.data.content);
                }
                if(that.dataList.length > 0){
                    this.flag = false
                }else{
                    this.flag = true
                }
                this.totalPages = res.data.totalPages;
                if (that.dataList.length == res.data.totalRecords) {
                    //显示数据没有了
                    that.loadingType = "noMore";
                } else {
                    //上拉显示更多
                    that.loadingType = "more";
                }
            }else{
                that.loadingType = "noMore";
                this.flag = true;
            }
        })
    },
    //时间处理
    conversionTime(timeStamp) {
        if (timeStamp > 0) {
            var date = new Date();
            date.setTime(timeStamp);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
            return y + '-' + m + '-' + d;
        } else {
            return '';
        }
    },
   },
   computed: {
      lotteryGold() {
        return this.$t('lotteryGold')
      }
   },
}
</script>
<style  lang="less">
    .lotteryGold{
        .nothing{
            width: 100%;
            text-align: center;
            font-size: 16px;
            // margin-left: 200px;
            img{
                width: 300px;
                height: 250px;
            }
        }
        .el-dialog__title{
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 10px;
        }
        .el-dialog__header {
            padding-top: 30px!important;
        }
        .dialog__footer {
            padding-bottom: 30px!important;
        }
        .cuosing{
            cursor: pointer;
        }
        .el-button{
            width: 140px;
            height: 50px;
            box-shadow: 0px 9px 9px 0px rgba(44, 44, 68, 0.12);
            border-radius: 30px;
            border: none;
            color: #607791;
        }
        .el-button:hover{
            border: none;
        }
        .el-dialog--center{
            border-radius: 8px;
        }
        .el-button--default,.el-button--default:hover,.el-button--default:active,.el-button--default:focus{
            background: #fff;
            border-radius:8px;
            border: 1px solid #E91919;
            color: #E91919;
            box-shadow: 0px 3px 6px rgba(245, 63, 63, 0.16);
            font-size: 16px;
        }
        .el-button--primary,.el-button--primary:hover,.el-button--primary:active,.el-button--primary:focus{
            background: #E91919;
            border-radius: 8px;
            border: none;
            color: #fff;
            margin-left: 36px;
            font-size: 16px;
        }
        .el-dialog__footer{
            padding: 10px 20px 20px!important;
        }
    }
    //notify样式
        .myNotify {
        min-width:300px !important;
        left: 50% !important;
        top: 50% !important;
        transform: translate(-50%, -50%) !important;
        display: flex;
        justify-content: center;
        padding: 0.15rem 0.3rem !important;
        background-color: #666 !important;
        .success {
            min-width: 1rem;
            height: 0.39rem;
            background-size: 100% 100%;
            margin-bottom: 0.1rem;
        }
        .el-notification__content {
            color: white !important;
            font-size: 0.18rem;
        }
        }
</style>
<style lang="less" scoped>
    .lotteryGold{
        .page{
            font-weight: bold;
            line-height: 49px;
        }
        .lottleList{
            height: 600px;
            text-align: center;
            .pageUl{
                margin-bottom: 22px;
                height: 68px;
                line-height: 68px;
                box-sizing: border-box;
                border-bottom: 1px solid #e8e8e8;
                li{
                    cursor: pointer;
                    padding: 0 6.2%;
                    font-size: 14px;
                    float: left;
                    box-sizing: border-box;
                    color: #333;
                }
                li:hover{
                    color: #d00;
                }
                .activited{
                    color: #d00;
                    height: 67.5px;
                    line-height: 67.5px;
                    box-sizing: border-box;
                    border-bottom: 2px solid #d00;
                }
            }
        }
        .lotterList{
            overflow: auto;
            padding: 10px;
            height: 580px;
            // display: flex;
            // flex-wrap: wrap;
            // justify-content: start;
            .setHeiaht{
                overflow: hidden;
            }
            .box{
                float: left;
                padding: 15px;
                text-align: left;
                width: 350px;
                height: 220px;
                margin-right: 61px;
                margin-bottom: 30px;
                background: #FFFFFF;
                border: 1px solid #DCDCDC;
                box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
                border-radius: 8px;
                box-sizing: border-box;
                position: relative;
                margin-left: 14px;
                 margin-top: 14px;
                 overflow: hidden;
               .goldTitme{
                    width: 100%;
                    margin-top: 10px;
                    font-size: 16px;
                    font-weight: 400;
                    color: #F35656;
                    line-height: 20px;
                    word-break: break-all;
               }
               .shoeMoney{
                    margin-top: 30px;
                    margin-bottom: 26px;
                    font-size: 30px;
                    font-weight: bolder;
                    color: #E91919;
                    line-height: 10px;
               }
               .showBtn{
                    width: 160px;
                    height: 40px;
                    cursor: pointer;
                    background: #E91919;
                    line-height: 40px;
                    border-radius: 6px;
                    font-size: 16px;
                    font-weight: 400;
                    color: #fff;
                    position: relative;
                    left: 50%;
                    // transform: translateX(-50%);
                    margin-bottom: 15px;
                    text-align: center;
               }
                .disbtn1{
                    background: #F48B8B;
                    color: #fff;
               }
               .disbtn{
                    background: #CCCCCC;
                    color: #fff;
               }
               .timeqq{
                    font-size: 14px;
                    font-weight: 400;
                    color: #313131;
                    line-height: 24px;
                    opacity: 0.5;
               }
            }
            .box:hover{
                box-shadow: 0 0 15px #ccc;
            }
            .Expired{
                .shoeMoney,.goldTitme{
                    color: #A7A7A7;
                }
            }
            .box:nth-child(2n){
                margin-right: 0;
            }
            .Atext{
                font-size: 16px;
                position: relative;
                left: 50%;
                transform: translateX(-50%);
            }
        }
      
        .showmonbox{
            .showmon{
                font-size: 30px;
                font-weight: 400;
                color: #E91919;
                line-height: 10px;
            }
            .bei{
                font-size: 16px;
                font-weight: 400;
                color: #313131;
                line-height: 24px;
                opacity: 0.5;
                margin-top: 20px;
            }
        }
    }
</style>